import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BAbanner from "../Page-section/business-automation/BAbanner";
import BAprocess from "../Page-section/business-automation/BAprocess";
import { useSEO } from "../hooks/useSEO";

function BusinessAutomation() {
  useSEO({
    title: "Business Automation Services That Save Time, Reduce Costs",
    description:
      "Get expert Business Automation Services to automate workflows, reduce manual work, and boost productivity. Start your free consultation today and grow faster!",
    canonical: "https://empowerweb.in/business-automation-services",
    ogTitle: "Business Development Automation | Process Automation Solutions",
    ogDescription:
      "Streamline operations with AI-driven business automation. Increase efficiency and reduce manual work.",
    keywords:
      "business automation services , automate business processes ,   process automation, business automation services in noida",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <BAbanner />
        <BAprocess />
      </main>
      <Footer />
     
     
    </div>
  );
}

export default BusinessAutomation;
